module.exports = __webpack_public_path__ + "img/特色基地营地.11248632.jpg";